@import "../../variables.scss";

.popup {
  &__width {
    width: 732px;

    @media (max-width: $size-md) {
      width: 100%;
    }
  }

  &__title {
    margin-bottom: 33px;

    @media (max-height: 600px) {
      margin-bottom: 16px;
    }
  }
}
